/**
 * @fileoverview Componente responsável por fornecer o contêiner base das páginas autenticadas.
 */

import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		width: '100%',
		maxWidth: '100%',
		padding: 0,
		margin: 0,
		height: `calc(100% - 48px)`,
		[theme.breakpoints.down("sm")]: {
			height: "100%",
			paddingBottom: "calc(64px + env(safe-area-inset-bottom))",
		},
		backgroundColor: theme.palette.type === 'light' ? '#ffffff' : '#0A0A0A',
		position: 'relative',
		'&::before': theme.palette.type === 'dark' ? {
			content: '""',
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundImage: `
				radial-gradient(circle at 20% 50%, rgba(91, 124, 255, 0.08) 0%, transparent 50%),
				radial-gradient(circle at 80% 80%, rgba(124, 58, 237, 0.08) 0%, transparent 50%),
				radial-gradient(circle at 40% 20%, rgba(59, 130, 246, 0.06) 0%, transparent 50%)
			`,
			pointerEvents: 'none',
			zIndex: 0,
		} : {},
	},

	contentWrapper: {
		height: "100%",
		width: '100%',
		overflowY: "auto",
		overflowX: "hidden",
		display: "flex",
		flexDirection: "column",
		position: 'relative',
		zIndex: 1,
		...theme.scrollbarStyles,
	},
}));

const MainContainer = ({ children, className }) => {
	const classes = useStyles();

	return (
		<Box className={`${classes.mainContainer} ${className || ''}`}>
			<div className={classes.contentWrapper}>{children}</div>
		</Box>
	);
};

export default MainContainer;
